import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';
import { ExperimentGate } from './lib/experiment-gate';

// One node per variant; the gate shows only the visitor's ABsmartly variant (matched by name).
export function Experiment({
  props,
}: NodeProps<{
  testName: string;
  variant: string;
  children: StructuredContent | StructuredContent[];
}>) {
  return (
    <ExperimentGate testName={props.testName} variant={props.variant}>
      <StructuredContentRenderer doc={props.children} />
    </ExperimentGate>
  );
}
